import { Navigation } from 'swiper/modules';
import { SwiperProps } from 'swiper/react';
export const sliderButtonJsClasses = {
    prev: 'js-sliderNavigationPrevButton',
    next: 'js-sliderNavigationNextButton',
};
export const baseSwiperConfig: SwiperProps = {
    modules: [Navigation],
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
        prevEl: `.${sliderButtonJsClasses.prev}`,
        nextEl: `.${sliderButtonJsClasses.next}`,
    },
    breakpoints: {
        661: {
            slidesPerView: 3,
        },
        980: {
            slidesPerView: 4,
        },
    },
};
